export function clearUrlParametersForPdfExport(s: string): string {
  return s?.replace(/(&|\?)*(wcmmode=disabled|results=true|step=.{1,2}&*)+&*|^\?*/g, '') || ''
}
